import { render } from "./GallerySection.vue?vue&type=template&id=0589e94a&scoped=true"
import script from "./GallerySection.vue?vue&type=script&lang=js"
export * from "./GallerySection.vue?vue&type=script&lang=js"

import "./GallerySection.vue?vue&type=style&index=0&id=0589e94a&lang=scss&scoped=true"

import exportComponent from "/Users/suzukitatsuya/kaon_r-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0589e94a"]])

export default __exports__